export default {
  "support.header": "Support",
  "support.about": "About us",
  "support.faq": "FAQ",
  "support.contact": "Contact us",
  "support.search.placeholder": "Example： Life science",
};
